import * as z from "zod";
import { userFacingError } from "../authorization";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { mutator } from "./mutator";
import { branchSchema } from "./utils";

export const setStepRouteAuthSchema = z
  .object({
    stepDir: z.string(),
    routeAuth: z.enum(["connector", "connected_app", "space"]),
  })
  .merge(branchSchema);

export const setStepRouteAuth = mutator({
  schema: setStepRouteAuthSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      routeAuth,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    if (branch.name === "main") {
      throw userFacingError(
        "Edit link auth on a draft branch first, then push live."
      );
    }
    const { commitId } = await ensureWritable(
      tx,
      ctx.userId,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );
    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, { routeAuth });
  },
});
